// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны

export interface IGetFavoritesForDesktopRequestSchema {
  /** Тип сделки **/
  dealType?: EDealType;
  /** Тип объявления **/
  entityTypes?: EEntityTypes[];
  /** id подборки **/
  folderId?: number;
  /** Кол-во объявлений в ответе **/
  limit?: number;
  /** Offset для пагинации по объявлениям **/
  offset?: number;
  /** Поле для сортировки **/
  orderField?: EOrderField;
  /** Порядок сортировки **/
  orderType?: EOrderType;
}

export enum EDealType {
  /** Аренда **/
  'Rent' = 'rent',
  /** Продажа **/
  'Sale' = 'sale',
}
export enum EEntityTypes {
  /** Коммерческая **/
  'Commercial' = 'commercial',
  /** ЖК **/
  'Newbuilding' = 'newbuilding',
  /** Жилая **/
  'Residential' = 'residential',
  /** Загородка **/
  'Suburban' = 'suburban',
}
export enum EOrderField {
  /** По дате добавлению в избранное **/
  'Added' = 'added',
  /** По дате создания объявления **/
  'Created' = 'created',
  /** По цене **/
  'Price' = 'price',
}
export enum EOrderType {
  /** По возрастанию **/
  'Asc' = 'asc',
  /** По убыванию **/
  'Desc' = 'desc',
}
